import { normalizeRouteTextColor } from "@/lib/transitDisplay";

function escapeSvgText(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function normalizeColor(routeColor) {
  if (!routeColor) return "#222B2D";
  return routeColor.startsWith("#") ? routeColor : `#${routeColor}`;
}

export const routeBadgeViewBox = {
  width: 100,
  height: 100,
};

export const routeBadgeShape = {
  type: "rounded_rect",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  cornerRadius: 20,
};

export function formatRouteLabel(label) {
  return String(label || "");
}

export function getOtagoRouteBadgeRenderSpec({
  routeLabel,
  routeColor,
  routeTextColor,
  route_text_color,
  route_short_name,
  service_id,
}) {
  const displayLabel = formatRouteLabel(
    routeLabel ?? route_short_name ?? service_id,
  );

  return {
    displayLabel,
    fillColor: normalizeColor(routeColor),
    textColor: normalizeRouteTextColor(
      routeTextColor ?? route_text_color,
      "white",
    ),
    fontSize: displayLabel.length > 1 ? 60 : 70,
    yPosition: displayLabel.length > 1 ? "71px" : "74px",
    fontWeight: 750,
    fontWidth: 100,
    letterSpacing: "0",
  };
}

export function createRouteBadgeSvg(route, { renderText } = {}) {
  const {
    displayLabel,
    fillColor,
    textColor,
    fontSize,
    yPosition,
    fontWeight,
    fontWidth,
    letterSpacing,
  } = getOtagoRouteBadgeRenderSpec(route);
  const textElement = renderText
    ? renderText({
        label: displayLabel,
        fill: textColor,
        x: "50%",
        y: yPosition,
        fontSize,
        fontWeight,
        fontWidth,
        letterSpacing,
      })
    : `<text fill="${textColor}" x="50%" y="${yPosition}" text-anchor="middle" font-size="${fontSize}" font-weight="${fontWeight}" font-stretch="${fontWidth}%" font-family="Bus, sans-serif" style="font-stretch: ${fontWidth}%; font-variation-settings: &quot;wdth&quot; ${fontWidth}, &quot;wght&quot; ${fontWeight};">${escapeSvgText(displayLabel)}</text>`;

  return `<svg viewBox="0 0 ${routeBadgeViewBox.width} ${routeBadgeViewBox.height}" width="128" height="128" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="${routeBadgeShape.width}" height="${routeBadgeShape.height}" x="${routeBadgeShape.x}" y="${routeBadgeShape.y}" fill="${fillColor}" rx="${routeBadgeShape.cornerRadius}"/>
  ${textElement}
</svg>`;
}
